<div class="row">
    <div class="text-center col-md-3 col-lg-2">
        <div *ngIf="product.pdfUrl !== null">
            <a (click)="showPreview(product)">
                <img
                    [src]="seeInsideIconUrl"
                    style="width: 100px;"
                />
            </a>
        </div>
        <div>
            <a (click)="product.pdfUrl != null ? showPreview(product) : onModalLoad(product)">
                <img
                    class="productImg"
                    [src]="product.imageUrl"
                />
            </a>
        </div>
    </div>
    <div class="col-md-6 col-lg-8">
        <a
            (click)="onModalLoad(product)"
            class="productName"
        >
            {{ product.name }}
        </a>
        <br />
        <br />
        <div>
            <p [innerHTML]="productShortDescription | safe: 'html'"></p>
        </div>
        <a
            class="modal-link"
            (click)="onModalLoad(product)"
        >
            Read More
        </a>
    </div>
    <div class="col-md-3 col-lg-2 text-center float-right">
        <div *ngIf="product.isPurchasable && product.listPrice > 0">
            <app-product-price [product]="product"></app-product-price>
            <a
                (click)="onAdd(product)"
                class="btn btn-primary"
            >
                Add To Cart
            </a>
        </div>
        <div *ngIf="product.productTypeId === ProductEBookId && product.isPurchasable && product.listPrice === 0">
            <a
                (click)="downloadPdf(product)"
                class="btn btn-primary"
            >
                Free Download
            </a>
        </div>
        <div *ngIf="!product.isPurchasable">
            <a
                (click)="onModalLoad(product)"
                class="btn btn-primary"
            >
                Read More
            </a>
        </div>
    </div>
</div>
